
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getCompanyActiveTeam, companyActiveTeam } from '@/utils/team';

type ITeamInfo = ITeam.IResponse.ITeamInfo;

@Component
export default class SelectTeam extends Vue {
  @Prop({default: () => []}) private excludeTeamIds!: string[];
  private defaultOptions: ITeamInfo[] = [];
  get teamOptions() {
    return this.defaultOptions.filter((team) => !this.excludeTeamIds.includes(team.id));
  }
  private created() {
    this.initTeams();
  }
  private initTeams() {
    if (companyActiveTeam.length === 0) {
    getCompanyActiveTeam().then(() => {
        this.defaultOptions = companyActiveTeam;
    }).catch((err) => {
        this.$message.warning(err);
    });
    } else {
    this.defaultOptions = companyActiveTeam;
    }
  }
  // 处理选项改变
  private handleChange(value: string | string[]) {
    this.$emit('change', value);
  }
}
